// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const PlanTasksBoardViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-plantasksboardview" */ "./PlanTasksBoardView")).then((page)=>{
        return {
            default: page.PlanTasksBoardView
        };
    });
export const LazyPlanTasksBoardView = /*#__PURE__*/ lazy(PlanTasksBoardViewLazyLoader);
